import PropTypes from 'prop-types';

export const MapSearchButton = function({allowLocationSearchSubmit, isLoading, submitLocationSearch}) {
    return (
        <button tabIndex="0" role="button" aria-label="Search requests" className='button-secondary'
                id='search-button' type='button' onClick={submitLocationSearch}>Search</button>
    );
};

MapSearchButton.propTypes = {
    allowLocationSearchSubmit: PropTypes.bool,
    isLoading: PropTypes.bool,
    submitLocationSearch: PropTypes.func,
}
